import GnaStatisticsVolumeAnylysis from "./GnaStatisticsVolume";
import GnaStatisticsCostAnylysis from "./GnaStatisticsCost";
const DataTabs = ["Volume", "Cost"];
export default function StatisticsAnylysis({
  selectedBlock,
  refreshKey,
  setError,
  activeTab,
  data =[],
  loading = false, // Add default value here
}: {
  selectedBlock: any[];
  refreshKey: number;
  setError?: any;
  activeTab?: string;
  data?: any[];
  loading?: boolean;
}) {
  return (
    <>
      <div className="py-3 px-3 bg-[#FAFBFD]">
        {activeTab === "Volume" && (
          <GnaStatisticsVolumeAnylysis
            selectedBlock={selectedBlock}
            refreshKey={refreshKey}
            setError={setError}
            loading={loading} // Now guaranteed to be boolean
            data={data}
          />
        )}
        {activeTab === "Cost" && (
          <GnaStatisticsCostAnylysis
            selectedBlock={selectedBlock}
            refreshKey={refreshKey}
            setError={setError}
            loading={loading} // Now guaranteed to be boolean
            data={data}
          />
        )}
      </div>
    </>
  );
}